import { render, staticRenderFns } from "./PurchasedSongs.vue?vue&type=template&id=6d1b6eda&scoped=true"
import script from "./PurchasedSongs.vue?vue&type=script&lang=js"
export * from "./PurchasedSongs.vue?vue&type=script&lang=js"
import style0 from "./PurchasedSongs.vue?vue&type=style&index=0&id=6d1b6eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1b6eda",
  null
  
)

export default component.exports